document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('[data-toggle="tab"]')) {
        import(/* webpackChunkName: "tabs" */ "/Assets/libs/tabs/tabs.js").then((module) => {
            module.default.initAll();
        });
    }
});